const INCREMENTS = [1500, 2500, 3500, 4500, 5000, 7500, 10000, 12500, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 55000, 60000, 65000, 70000, 75000, 80000, 85000, 90000, 95000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000]
const ADVANCE_RATE = [
  [/*     */ 0, 0.73],
  [/*  */ 5000, 0.75],
  [/* */ 10000, 1.25],
  [/* */ 25000, 1.38],
  [/* */ 50000, 1.51],
  [/**/ 150000, 1.56],
  [/**/ 300000, 1.56]
]
const FEE_PERCENT = [
  [/*     */ 0, 0.16],
  [/*  */ 5000, 0.16],
  [/* */ 10000, 0.16],
  [/* */ 25000, 0.13],
  [/* */ 50000, 0.13],
  [/**/ 150000, 0.10],
  [/**/ 300000, 0.10]
]
const INITIAL_INCREMENT = 6
const YOULEND_URL = 'https://youlend.com/paymentsense/youlendadvancesignupv3?companyName=PaymentSense&tpi=crn0'

export default class AdvanceCalculator {
    constructor($el) {
        this.$sliderContainer = $el.querySelector(`.ps-advance-calculator__range-slider`)
        this.$trackLower = document.createElement('div')
        this.$slider = $el.querySelector(`#ps-advance-calculator__range-slider`)
        this.$revenue = $el.querySelector(`#ps-advance-calculator__revenue`)
        this.$advance = $el.querySelector(`#ps-advance-calculator__advance`)
        this.$advanceFee = $el.querySelector(`#ps-advance-calculator__advance-fee`)
        this.$advanceTotal = $el.querySelector(`#ps-advance-calculator__advance-total`)
        this.$button = $el.querySelector(`.ps-button`)
        this.youLendChannel = this.$button.getAttribute('data-youlend-channel')
    }

    init() {
        this.$sliderContainer.appendChild(this.$trackLower)
        this.currentIncrement = INITIAL_INCREMENT
        this.setTrack()
        this.renderTrackLower()
        this.$slider.addEventListener('input', this.updateData.bind(this))
        this.$slider.addEventListener('change', this.updateLink.bind(this))


        window.addEventListener('orientationchange', this.setTrack.bind(this));
        window.addEventListener('resize', this.setTrack.bind(this));
    }

    setTrack() {
        this.$sliderContainerWidthIncrement = this.$sliderContainer.offsetWidth / INCREMENTS.length
        this.renderTrackLower(this.currentIncrement)
    }

    renderTrackLower(increment) {
        this.$trackLower.style.width = `${(this.$sliderContainerWidthIncrement * increment) + 4}px`
    }

    updateData() {
        this.currentIncrement = this.$slider.value
        this.renderTrackLower(this.$slider.value)
        let revenue = INCREMENTS[this.$slider.value]
        let formattedRevenue = this.formatNumber(revenue)
        this.$revenue.innerHTML = `£${formattedRevenue}`
        // Update Advance
        let advanceAmount = this.advanceAmount(revenue)
        let formattedAdvanceAmount = this.formatNumber(advanceAmount.toFixed())
        this.$advance.innerHTML = `£${formattedAdvanceAmount}`
        // Update Fee
        let feeAmount = this.feeAmount(revenue, advanceAmount)
        let feePercent = this.feePercent(revenue)
        let formattedFeeAmount = this.formatNumber(feeAmount.toFixed())
        let formattedFeePercent = this.formatNumber(feePercent.toFixed())
        this.$advanceFee.innerHTML = `£${formattedFeeAmount} (${formattedFeePercent}%)`
        // Update Total
        let totalAmount = advanceAmount + feeAmount
        let formattedTotalAmount = this.formatNumber(totalAmount.toFixed())
        this.$advanceTotal.innerHTML = `£${formattedTotalAmount}`
    }

    updateLink() {
        this.updateData()
        let revenue = INCREMENTS[this.$slider.value]
        let advanceAmount = this.advanceAmount(revenue)
        this.$button.href = `${YOULEND_URL}&fundingAmount=${advanceAmount.toFixed()}&monthlyRevenue=${revenue.toFixed()}&channel=${this.youLendChannel}`
    }

    advanceAmount(revenue) {
        let chosenRate = undefined
        for (var rateInfo of ADVANCE_RATE) {
            if (revenue >= rateInfo[0]) {
                chosenRate = rateInfo[1]
            }
            else {
                break
            }
        }
        return revenue * chosenRate
    }

    feeAmount(revenue, advance) {
        return this.getFeePercent(revenue) * advance
    }

    feePercent(revenue) {
        return this.getFeePercent(revenue) * 100
    }

    getFeePercent(revenue) {
        let chosenRate = undefined
        for (var rateInfo of FEE_PERCENT) {
            if (revenue >= rateInfo[0]) {
                chosenRate = rateInfo[1]
            }
            else {
                break
            }
        }
        return chosenRate
    }

    formatNumber(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
}



// WEBPACK FOOTER //
// ./js/modules/AdvanceCalculator.js